export default {
  app_name: 'Piola',
  website: 'https://www.piola.co.il',
  finance_email: 'finance@piola.co.il',
  phone_number: '03-5755026'
}
